var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgIconHtml = function SvgIconHtml(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06662 8.28905C9.39856 8.621 9.39856 9.15919 9.06662 9.49113L6.66766 11.8901L9.06662 14.289C9.39856 14.621 9.39856 15.1592 9.06662 15.4911C8.73467 15.8231 8.19648 15.8231 7.86454 15.4911L4.86454 12.4911C4.53259 12.1592 4.53259 11.621 4.86454 11.289L7.86454 8.28905C8.19648 7.9571 8.73467 7.9571 9.06662 8.28905Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8645 15.4911C14.5326 15.1592 14.5326 14.621 14.8645 14.2891L17.2635 11.8901L14.8645 9.49113C14.5326 9.15919 14.5326 8.621 14.8645 8.28905C15.1965 7.9571 15.7347 7.9571 16.0666 8.28905L19.0666 11.2891C19.3986 11.621 19.3986 12.1592 19.0666 12.4911L16.0666 15.4911C15.7347 15.8231 15.1965 15.8231 14.8645 15.4911Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2902 6.09625C13.7456 6.2101 14.0225 6.6716 13.9087 7.12702L11.4105 17.1195C11.2967 17.5749 10.8352 17.8518 10.3798 17.738C9.92434 17.6241 9.64745 17.1626 9.7613 16.7072L12.2594 6.71471C12.3733 6.25929 12.8348 5.98239 13.2902 6.09625Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHtml, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_html.f98acee1.svg";
export { ForwardRef as ReactComponent };